import { render, staticRenderFns } from "./LinkMetaTrader.vue?vue&type=template&id=686f333b&scoped=true"
import script from "./LinkMetaTrader.vue?vue&type=script&lang=js"
export * from "./LinkMetaTrader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686f333b",
  null
  
)

export default component.exports